export default __webpack_public_path__ + "static/media/error.053bc96a.png";